export const remoteEvents = [
  {
    eventId: '8a7359bf-33b6-4b3a-836f-7947af3d9857',
    acts: [
      {
        id: 'd25f1720-38f4-4c7a-9905-dfbfc5c76862',
        eventPartition: '1/1',
        time: '1687875455114',
        type: 'NOTE_UPDATE_CONTENT',
        payload: {
          entityId: '4d99a84b-9b21-44c5-9bf6-d1d217519e82',
          content:
            'Это объект, внутри которого была создана функция.\nКонтекст определяется в момент вызова функции.\nthis является ссылкой на контекст.\n\nLexicalEnvironment\nВсе переменные внутри функции – это свойства специального внутреннего объекта LexicalEnvironment, который создаётся при её запуске.\n\nИнтерпретатор, при доступе к переменной, сначала пытается найти переменную в текущем LexicalEnvironment, а затем, если её нет – ищет во внешнем объекте переменных. В данном случае им является window.\n\nЭто возможно через поле Scope у функции, это поле скрыто.\n\nЕсли обобщить:\n— Каждая функция при создании получает ссылку [[Scope]] на объект с переменными, в контексте которого была создана.\n— При запуске функции создаётся новый объект с переменными LexicalEnvironment. Он получает ссылку на внешний объект переменных из [[Scope]].\n—При поиске переменных он осуществляется сначала в текущем объекте переменных, а потом – по этой ссылке.\n\nВ браузере this === window\nВ ноде this === global\n\nВ строгом режиме this === undefined\n\nКаррирование — привязывание не только контекста, но и аргументов.\n\nПочитать насчёт Замыкания, Scope, LexicalEnvironment.\n\nhttps://habr.com/company/ruvds/blog/422089/\n\nНемного новых данных.',
          hash: '97a2e390113d627de720d8a83fcb3dd6c70f0ff2',
        },
      },
    ],
    time: '1687875455114',
  },
  {
    eventId: 'ab067376-77ad-4e48-b615-32a45aaab30d',
    acts: [
      {
        id: '8a87ad05-0820-4728-879f-6644a0296ed2',
        eventPartition: '1/3',
        time: '1687875375547',
        type: 'COLLECTION_UPDATE_CHILD',
        payload: {
          entityId: 'd5966631-9a4a-47dd-ac09-dd2984a8b125',
          children: [
            {
              id: '4d99a84b-9b21-44c5-9bf6-d1d217519e82',
              type: 'note',
            },
          ],
          move: 'REMOVE',
          position: 0,
        },
      },
      {
        id: '744da060-c052-4789-8f82-7127e1e44e9c',
        eventPartition: '2/3',
        time: '1687875375547',
        type: 'COLLECTION_UPDATE_CHILD',
        payload: {
          entityId: '33288900-c01e-43ff-8c83-e900f141adde',
          children: [
            {
              id: '4d99a84b-9b21-44c5-9bf6-d1d217519e82',
              type: 'note',
            },
          ],
          move: 'ADD',
          position: -1,
        },
      },
      {
        id: '880a8047-9af9-4a17-8435-abdca4262d93',
        eventPartition: '3/3',
        time: '1687875375547',
        type: 'NODE_PARENT_UPDATE',
        payload: {
          ref: {
            id: '4d99a84b-9b21-44c5-9bf6-d1d217519e82',
            type: 'note',
          },
          parentId: '33288900-c01e-43ff-8c83-e900f141adde',
        },
      },
    ],
    time: '1687875375547',
  },
  {
    eventId: '8a7359bf-33b6-4b3a-836f-7947af3d9860',
    acts: [
      {
        id: 'd25f1720-38f4-4c7a-9905-dfbfc5c76862',
        eventPartition: '1/1',
        time: '1687875455255',
        type: 'NOTE_UPDATE_CONTENT',
        payload: {
          entityId: '4d99a84b-9b21-44c5-9bf6-d1d217519e82',
          content:
            'Это объект, внутри которого была создана функция.\nКонтекст определяется в момент вызова функции.\nthis является ссылкой на контекст.\n\nLexicalEnvironment\nВсе переменные внутри функции – это свойства специального внутреннего объекта LexicalEnvironment, который создаётся при её запуске.\n\nИнтерпретатор, при доступе к переменной, сначала пытается найти переменную в текущем LexicalEnvironment, а затем, если её нет – ищет во внешнем объекте переменных. В данном случае им является window.\n\nЭто возможно через поле Scope у функции, это поле скрыто.\n\nЕсли обобщить:\n— Каждая функция при создании получает ссылку [[Scope]] на объект с переменными, в контексте которого была создана.\n— При запуске функции создаётся новый объект с переменными LexicalEnvironment. Он получает ссылку на внешний объект переменных из [[Scope]].\n—При поиске переменных он осуществляется сначала в текущем объекте переменных, а потом – по этой ссылке.\n\nВ браузере this === window\nВ ноде this === global\n\nВ строгом режиме this === undefined\n\nКаррирование — привязывание не только контекста, но и аргументов.\n\nПочитать насчёт Замыкания, Scope, LexicalEnvironment.\n\nhttps://habr.com/company/ruvds/blog/422089/\n\nНемного новых данных.\nИ ещё обновление в конце.',
          hash: '97a2e390113d627de720d8a83fcb3dd6c70f0ff2',
        },
      },
    ],
    time: '1687875455255',
  },
  {
    eventId: '8a7359bf-33b6-4b3a-836f-7947af3d0002',
    acts: [
      {
        id: 'd25f1720-38f4-4c7a-9905-dfbfc5c00002',
        eventPartition: '1/1',
        time: '1687875455114',
        type: 'NOTE_UPDATE_CONTENT',
        payload: {
          entityId: '4d99a84b-9b21-44c5-9bf6-d1d21e000002',
          content: 'Some remote text to fix.',
          hash: '97a2e390113d627de720d8a83fcb3dd6c70f0ff2',
        },
      },
    ],
    time: '1687875455114',
  },
];
